module.exports = __webpack_public_path__ + "static/media/store-ITunes.7dae1913.svg";